module.exports = __webpack_public_path__ + "static/media/0_2020_03_28.87759d92.jpg";